import { Table } from 'antd';

const HourLogBreakdown = ({period}) => {
  const columns = [
    {dataIndex: 'projectorBillableHours', title: 'Projector Billable Hours'},
    {dataIndex: 'projectorNonBillableHours', title: 'Projector Non-Billable Hours'},
    {dataIndex: 'projectorTimeOffHours', title: 'Projector Time Off Hours'},
    {dataIndex: 'hourLogBillableHours', title: 'Hour Log Billable Hours'},
    {dataIndex: 'hourLogNonBillableHours', title: 'Hour Log Non-Billable Hours'},
    {dataIndex: 'hourLogTimeOffHours', title: 'Hour Log Time Off Hours'}
  ];

  return (
    <Table
      rowKey="ID"
      dataSource={[period]}
      columns={columns}
      pagination={false}
    />
  );
};

export { HourLogBreakdown };